import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

export const UserPicture = styled.img`
	width: 100px;
	height: 100px;
	border-radius: 50%;
`;

export const UserName = styled.span`
	${({ theme }) => theme.typography.headlines.h5};
	color: ${({ theme }) => theme.colors.body.medium};
	margin-top: 12px;
`;

export const UserInfo = styled.span`
	${({ theme }) => theme.typography.label.medium};
	color: ${({ theme }) => theme.colors.body.light};
	text-align: center;
	margin-top: 8px;
`;
